import { useQuery } from '@tanstack/react-query'
import { webApi } from '@/services/webApi'
import { normalizePremiumPackage } from '@/lib/premiumNormalize'

export function usePremiumPackages() {
  const query = useQuery({
    queryKey: ['web', 'premium-packages'],
    queryFn: webApi.premiumPackages,
  })

  const marketingPackages =
    query.data?.marketingPackages.map((pkg, i) => normalizePremiumPackage(pkg, i)) ?? []

  const otherProducts =
    query.data?.otherProducts.map((pkg, i) => normalizePremiumPackage(pkg, i + 10)) ?? []

  return {
    ...query,
    marketingPackages,
    otherProducts,
  }
}

export function usePremiumPaymentConfig() {
  return useQuery({
    queryKey: ['web', 'premium-payment-config'],
    queryFn: webApi.premiumPaymentConfig,
    staleTime: 5 * 60 * 1000,
  })
}
